export const repackagingResources = {
  fr: {
    card: { reference: "Référence de reconditionnement", packaging: "Conditionnement" },
    module: "Reconditionnement", title: "Reconditionnement",
    searchPlaceholder: "Tâche, HU, article…",
    tabs: { open: "Tâches ouvertes", closed: "Tâches clôturées" },
    tabsMobile: { open: "OUVERTES", closed: "CLÔTURÉES" },
    filters: {
      warehouse: "Entrepôt", dateOrder: "Ordre de date",
      syntaxPlaceholder: "id:HU-001 conditionnement:CARTON statut:OPEN",
      syntaxHelp: "id:, article:, serie:, entrepot:, gare:, raison:, conditionnement:, statut:, date:"
    },
    actions: {
      claimTransfer: "Prendre en charge le transfert", confirmDeposit: "Confirmer le dépôt",
      claim: "Prendre en charge", continue: "Continuer", handleException: "Traiter l’exception",
      view: "Consulter", select: "Sélectionner une tâche", fullDetails: "Actions et informations complètes",
      reportProblem: "Signaler un problème", finish: "Terminer et relancer la mise en stock",
      applyResolution: "Appliquer la résolution", report: "Signaler"
    },
    labels: {
      undefined: "Non défini", packaging: "conditionnement {{packaging}}",
      transferStep: "Transfert vers reconditionnement", step: "Reconditionnement",
      details: "Afficher le détail", requestDetails: "Détail de la demande",
      reason: "Motif : {{reason}}", processingStation: "Gare de traitement : {{station}}",
      transferInProgress: "Transfert en cours", transferStatus: "{{source}} → {{destination}} · statut {{status}}",
      technicalId: "Identifiant technique : {{id}}", task: "Reconditionnement {{number}}",
      itemTraceability: "Article et traçabilité", serialNumber: "S/N : {{numbers}}",
      originalPackaging: "Conditionnement avant traitement : {{packaging}}",
      assignedTo: "Affectée à {{user}}", targetPackaging: "Conditionnement cible",
      departureStation: "Gare de départ", repackagingComment: "Commentaire de reconditionnement",
      resolutionAction: "Action de résolution", resolutionComment: "Commentaire de résolution",
      newPackaging: "Nouveau conditionnement : {{packaging}}.", reportDialog: "Signaler un problème de reconditionnement",
      reasonField: "Motif", comment: "Commentaire"
    },
    resolutions: {
      RETRY: "Reprendre le reconditionnement", SEND_TO_QUALITY: "Envoyer en contrôle qualité",
      CANCEL: "Annuler et renvoyer en traitement manuel"
    },
    exceptions: {
      PACKAGING_UNAVAILABLE: "Conditionnement indisponible", PACKAGING_DAMAGED: "Conditionnement endommagé",
      HU_DAMAGED: "HU endommagée", IDENTIFICATION_MISMATCH: "Identification incohérente",
      PROCESS_POINT_UNAVAILABLE: "Gare indisponible", OTHER: "Autre"
    },
    help: { requiredThree: "Obligatoire — minimum 3 caractères" },
    empty: {
      all: "Aucune tâche de reconditionnement.", filtered: "Aucune tâche ne correspond aux filtres."
    },
    errors: {
      load: "Impossible de charger les tâches de reconditionnement.", claim: "Prise en charge impossible.",
      transfer: "L’action de transfert a échoué.", complete: "Validation impossible.",
      report: "Signalement impossible.", resolve: "Résolution impossible.",
      noPackaging: "Aucun conditionnement actif n’est associé à cet article.",
      missingTransfer: "La tâche attend un transfert, mais aucun transfert ouvert associé n’a été retrouvé."
    }
  },
  en: {
    card: { reference: "Repackaging reference", packaging: "Packaging" },
    module: "Repackaging", title: "Repackaging",
    searchPlaceholder: "Task, HU, material…",
    tabs: { open: "Open tasks", closed: "Closed tasks" },
    tabsMobile: { open: "OPEN", closed: "CLOSED" },
    filters: {
      warehouse: "Warehouse", dateOrder: "Date order",
      syntaxPlaceholder: "id:HU-001 packaging:CARTON status:OPEN",
      syntaxHelp: "id:, item:, serial:, warehouse:, station:, reason:, packaging:, status:, date:"
    },
    actions: {
      claimTransfer: "Take charge of transfer", confirmDeposit: "Confirm deposit",
      claim: "Take charge", continue: "Continue", handleException: "Handle exception",
      view: "View", select: "Select a task", fullDetails: "Full actions and information",
      reportProblem: "Report a problem", finish: "Complete and restart putaway",
      applyResolution: "Apply resolution", report: "Report"
    },
    labels: {
      undefined: "Not defined", packaging: "packaging {{packaging}}",
      transferStep: "Transfer to repackaging", step: "Repackaging",
      details: "Show details", requestDetails: "Request details",
      reason: "Reason: {{reason}}", processingStation: "Processing station: {{station}}",
      transferInProgress: "Transfer in progress", transferStatus: "{{source}} → {{destination}} · status {{status}}",
      technicalId: "Technical identifier: {{id}}", task: "Repackaging {{number}}",
      itemTraceability: "Material and traceability", serialNumber: "S/N: {{numbers}}",
      originalPackaging: "Packaging before processing: {{packaging}}",
      assignedTo: "Assigned to {{user}}", targetPackaging: "Target packaging",
      departureStation: "Departure station", repackagingComment: "Repackaging comment",
      resolutionAction: "Resolution action", resolutionComment: "Resolution comment",
      newPackaging: "New packaging: {{packaging}}.", reportDialog: "Report a repackaging problem",
      reasonField: "Reason", comment: "Comment"
    },
    resolutions: {
      RETRY: "Resume repackaging", SEND_TO_QUALITY: "Send to quality control",
      CANCEL: "Cancel and return to manual processing"
    },
    exceptions: {
      PACKAGING_UNAVAILABLE: "Packaging unavailable", PACKAGING_DAMAGED: "Packaging damaged",
      HU_DAMAGED: "HU damaged", IDENTIFICATION_MISMATCH: "Identification mismatch",
      PROCESS_POINT_UNAVAILABLE: "Station unavailable", OTHER: "Other"
    },
    help: { requiredThree: "Required — at least 3 characters" },
    empty: { all: "No repackaging task.", filtered: "No task matches the filters." },
    errors: {
      load: "Unable to load repackaging tasks.", claim: "Unable to take charge.",
      transfer: "Transfer action failed.", complete: "Unable to validate.",
      report: "Unable to report the problem.", resolve: "Unable to resolve the exception.",
      noPackaging: "No active packaging is associated with this material.",
      missingTransfer: "The task is waiting for a transfer, but no associated open transfer was found."
    }
  }
} as const;
